"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = __importDefault(require("../colors"));
const autocomplete = {
    MuiAutocomplete: {
        styleOverrides: {
            listbox: {
                "& .MuiAutocomplete-option": {
                    padding: "10px 17px",
                    fontSize: "0.9rem !important",
                },
                "& .MuiAutocomplete-option.Mui-focused": {
                    backgroundColor: colors_1.default.secondaryHover[600],
                },
                "& .MuiAutocomplete-option[aria-selected='true']": {
                    background: `${colors_1.default.secondarySelected[600]} !important`,
                },
            },
            root: {
                "& .MuiAutocomplete-inputRoot": { padding: "10px 30px 10px 15px" },
                "& .MuiAutocomplete-endAdornment": { top: "auto", right: "0.5rem" },
            },
        },
    },
};
exports.default = autocomplete;
